import { render, staticRenderFns } from "./BalikobotTimeline.vue?vue&type=template&id=ac491290&scoped=true&"
import script from "./BalikobotTimeline.vue?vue&type=script&lang=js&"
export * from "./BalikobotTimeline.vue?vue&type=script&lang=js&"
import style0 from "./BalikobotTimeline.vue?vue&type=style&index=0&id=ac491290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac491290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCol,VRow,VTimeline,VTimelineItem})
